
export default{
    breed:[ 
        {
            key : 'sve rase',
            sr : 'sve rase',
            en : 'all breeds',
        },
        
    ]
}
